import {useContext, useState} from 'react'
import {formatPrice} from '../../../../utils/common'
import PaymentDetailsModal from '../modals/PaymentDetailsModal'
import { PaymentCalenderPageContext } from '../../contexts'

const CalendarEvent = ({event}: any) => {
  const {setSelectedDate} = useContext(PaymentCalenderPageContext)
  const {totalAmount, poCount, hasPayment, date } = event.extendedProps
  const [showEventDetailsModal, setShowEventDetailsModal] = useState(false)

  const handleEventClick = () => {
    // Only open popup if there's payment data available
    if ((totalAmount > 0 || poCount) && date) {
      setShowEventDetailsModal(true)
      setSelectedDate(date)
    }
  }

  return (
    <>
      <div
        className='d-flex flex-column px-4 py-2 cursor-pointer border-primary border rounded bg-light-primary text-primary'
        onClick={handleEventClick}
      >
        {hasPayment ? (
          <>
            <div className='fw-bold fs-12'>{formatPrice(totalAmount, false)}</div>
            <div className='text-sm'>{poCount} POs</div>
          </>
        ) : (
          <>
            <div className='fw-bold fs-12'>No Payment</div>
            <div className='text-sm'>{poCount} POs</div>
          </>
        )}
      </div>

      {showEventDetailsModal && (
        <PaymentDetailsModal
          show={showEventDetailsModal}
          onClose={() => setShowEventDetailsModal(false)}
          selectedDate={date}
        />
      )}
    </>
  )
}

export default CalendarEvent
